import React, { useEffect } from "react";
import BannerImage from "../../assets/images/bussiness.jpg";
import { initializeAOS } from "../../Aos";

const HeroBanner = () => {
  useEffect(() => {
    initializeAOS();
  }, []);

  return (
    <section className="bg-[#D9F4EF] pt-[80px] pb-[80px]">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">

          {/* LEFT CONTENT */}
          <div data-aos="fade-right">
            {/* Badge */}
            <span className="inline-block mb-6 px-4 py-1.5 text-sm text-[#6B7280] bg-white rounded-full">
              Our story
            </span>

            {/* Heading */}
            <h1 className="text-[#111827] text-[34px] sm:text-[40px] lg:text-[46px] font-semibold leading-tight mb-6 max-w-xl">
              Financing that moves at the speed of your business
            </h1>

            {/* Description */}
            <p className="text-[#6B7280] text-base leading-relaxed max-w-xl mb-8">
              Invexflow helps growing companies unlock working capital by
              advancing cash against outstanding invoices. We combine
              underwriting expertise with modern rails to deliver fast,
              transparent funding.
            </p>

            {/* Feature Chips */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              {[
                "Bank-grade security",
                "Transparent pricing",
                "Same-day decisions",
              ].map((item, index) => (
                <span
                  key={index}
                  className="px-2 py-2 text-sm text-[#0F766E] rounded-full bg-transparent"
                >
                  {item}
                </span>
              ))}
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div
            data-aos="fade-left"
            className="flex justify-center lg:justify-end"
          >
            <img
              src={BannerImage}
              alt="Invexflow Office"
              className="w-full max-w-[520px] rounded-[18px] object-cover shadow-md"
            />
          </div>

        </div>
      </div>
    </section>
  );
};

export default HeroBanner;
